import { instance } from "api/apiBase";
import { Applicant } from "types/application";
import { ApplicationDecision, ApplicationSummary } from "./types";

const api = {
  getApplicationSummary: async (id: string): Promise<ApplicationSummary> => {
    return (
      await instance.get<ApplicationSummary>(
        `/portal/v1/applications/${id}/summary`
      )
    ).data;
  },
  getApplicationDecision: async (id: string): Promise<ApplicationDecision> => {
    return (
      await instance.get<ApplicationDecision>(
        `/portal/v1/applications/${id}/decision`
      )
    ).data;
  },
  getApplicantDetail: async (
    applicationId: string,
    applicantId: string
  ): Promise<Applicant> => {
    return (
      await instance.get<Applicant>(
        `/portal/v1/applications/${applicationId}/applicants/${applicantId}`
      )
    ).data;
  },
  createDocumentRequest: async ({
    applicationId,
    applicantId,
    note
  }: {
    applicationId: string;
    applicantId: string;
    note: string;
  }): Promise<Applicant> => {
    return (
      await instance.post<Applicant>(
        `/portal/v1/applications/${applicationId}/applicants/${applicantId}/document_requests`,
        { note }
      )
    ).data;
  },
  markDocumentRequestsSeen: async ({
    applicantId,
    applicationId
  }: {
    applicationId: string;
    applicantId: string;
  }): Promise<Applicant> => {
    return (
      await instance.patch<Applicant>(
        `/portal/v1/applications/${applicationId}/applicants/${applicantId}/document_requests/mark_seen`
      )
    ).data;
  }
};

export default api;
